import React, { useState } from 'react';
import { BsGear, BsArchive, BsLink45Deg } from "react-icons/bs";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import './banner.modules.css';


const LanguageWithPopover = ({ index, language, target }) => {
    const [popoverOpen, setPopoverOpen] = useState(false);
    //
    return (
        <Popover
            placement="left" isOpen={popoverOpen}
            target={target}

            toggle={() => {
                setPopoverOpen(!popoverOpen);
                setTimeout(() => { setPopoverOpen(false) }, 1000);
            }}
        >
            <PopoverHeader style={{ color: 'green' }}>Ссылка для {language.name} лкализации скопирована в буфер обмена</PopoverHeader>

        </Popover>
    );
};

const BannerListItem = ({ banner, projectGuid, onArchiveBannerHandler, onEditBannerHandler }) => {
    const { id, name, description, bannerEventType, languages, requests } = banner;

    return (
        <div className='list-row'>
            <div className='center id'>{id}</div>
            <div className='flex-start name'>
                {name} {description.length !== 0 ? `(${description })` : ''}
             </div>
            <div className='center type'>{bannerEventType === 0 ? 'Line' : 'Live'}</div>

            <div className='center localization'>
                {languages.map((language, index) => {
                    const link = "https://feedapi.live/api/v1/banner/" + projectGuid + '/' + banner.bannerGuid + '/' + language.uriName;
                    return (
                        <div id={'popover' + banner.id + index} key={link}>
                            <CopyToClipboard text={"https://feedapi.live/api/v1/banner/" + projectGuid + '/' + banner.bannerGuid + '/' + language.uriName} onCopy={() => console.log('Скопировано в буфер обмена')}>

                                <span
                                    
                                    style={{ cursor: 'pointer' }}
                                >
                                    {language.name} <BsLink45Deg />
                                </span>

                            </CopyToClipboard>
                            <LanguageWithPopover
                                language={language}
                                index={index}
                                target={'popover' + banner.id + index}
                            />

                        </div>
                    )
                })}
            </div>

            <div className='center status'>
                {languages.map((language, index) => {
                    const currentStatus = requests?.find(x => x.languageId === language.id)?.statusCode;
                    let status;
                    if (currentStatus)
                        status = currentStatus === 200 ? 'status ok' : 'status error';
                    else
                        status = "";

                    //console.log('status code', currentStatus);

                    return (
                        <div className={status} key={language.id + '-' + language.name + '-status'}>
                            {currentStatus === 200 ? "Ok" : (status.length === 0 ? "Подготовка" : "Ошибка")}
                        </div>
                    )
                })}
            </div>

            <div className='center actions'>
                <BsGear className='icon-button' color='green' onClick={() => onEditBannerHandler(id)} />
                <BsArchive className='icon-button' color='red' onClick={() => onArchiveBannerHandler(id)} />
            </div>
        </div>
    );
};

export default BannerListItem;


//<span
//    style={{ cursor: 'pointer' }}
//>
//    {language.name}<BsLink45Deg />

//</span>